import { routes } from '../routes/routes';

export const useLogout = () => () => {
	localStorage.removeItem('refresh');
	localStorage.removeItem('token');
	window.location.replace(routes.signIn);
};
